export const CATEGORIES = [
  "Pizzeria",
  "Steakhouse",
  "Coffee Shop",
  "Bakery & Ice Cream",
  "Diner",
  "Bar & Grill",
  "Mexican",
  "Asian",
  "Seafood",
  "Café / Deli",
  "Fine Dining",
  "Other",
];

export const PERK_SUGGESTIONS = {
  "Pizzeria": ["1 Free Large Pizza Monthly", "20% Off Every Order", "Free Garlic Knots Weekly"],
  "Steakhouse": ["Free Appetizer Monthly", "Members-Only Lounge Access", "Priority Reservations"],
  "Coffee Shop": ["Free Drink Weekly", "Double Loyalty Points", "10% Off Beans & Merch"],
  "Bakery & Ice Cream": ["Free Treat Monthly", "Buy-One-Get-One Weekly", "Birthday Cake Discount"],
  "Diner": ["Free Coffee Refills", "Free Breakfast Monthly", "15% Off Every Bill"],
  "Bar & Grill": ["Free App on Game Days", "Members Happy Hour All Day", "Free Wings Monthly"],
  "Mexican": ["Free Chips & Guac Every Visit", "Free Entrée Monthly", "Taco Tuesday Discount"],
  "Asian": ["Free Spring Rolls Monthly", "10% Off Every Order", "Free Bubble Tea Weekly"],
  "Seafood": ["Free Appetizer Monthly", "Market-Price Discount", "Priority Reservations"],
  "Café / Deli": ["Free Sandwich Monthly", "Free Coffee Weekly", "10% Off Catering"],
  "Fine Dining": ["Complimentary Champagne", "Priority Reservations", "Chef's Tasting Discount"],
  "Other": ["Monthly Freebie", "Member Discount on Every Order", "Exclusive Weekly Deal"],
};

